import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ApBaseClass, FPDocumentPrintingEventArgs } from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class FPDocumentPrintingService extends ApBaseClass implements OnDestroy {
  private onDocumentChanged$: Subject<FPDocumentPrintingEventArgs> = new Subject<FPDocumentPrintingEventArgs>();

  override ngOnDestroy(): void {
    this.onDocumentChanged$.complete();
  }

  onDocumentChanged() {
    return this.onDocumentChanged$.asObservable();
  }

  notifyDocumentChanged(eventArgs: FPDocumentPrintingEventArgs) {
    this.onDocumentChanged$.next(eventArgs);
  }
}
